import { render, staticRenderFns } from "./SubTitleComponent.vue?vue&type=template&id=a2ca1b3a&"
import script from "./SubTitleComponent.vue?vue&type=script&lang=js&"
export * from "./SubTitleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports